import React from "react";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router-dom";
import Button from "../Button";

const useStyles = makeStyles({
  container: {
    display: "flex",
    minWidth: 200,
    whiteSpace: "nowrap",
    justifyContent: "flex-end",
  },
});

export default function () {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = (url) => () => {
    history.push(url);
  };

  return (
    <div className={classes.container}>
      <Button isBlue={false} onClick={handleClick("/login")}>
        Login
      </Button>
      <Button isBlue={true} onClick={handleClick("/pendaftaran")}>
        Buat Akun
      </Button>
    </div>
  );
}
